module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/missed-call-79ed4f3f237e052cabd2c2626e5c1917.svg";